<template>
  <article class="local-page">
    <EventHero :event="event" />
    <EventSummary :event="event" heading="A Reckon Moment Close to Home" kicker="Local Event" />
    <EventDetailsCard :details="details" />
    <EntitySection :items="event.venues" :entity-by-id="entityById" section-id="venue" title="Where We Met" />
    <CrewSection :crew="event.crew" />
    <EventGallery v-if="event.gallery && event.gallery.length > 1" :media="event.gallery" :title="`${event.title} Moments`" />
  </article>
</template>

<script>
import EventHero from '../event/EventHero.vue';
import EventSummary from '../event/EventSummary.vue';
import EventDetailsCard from '../event/EventDetailsCard.vue';
import EntitySection from '../entities/EntitySection.vue';
import CrewSection from '../people/CrewSection.vue';
import EventGallery from '../media/EventGallery.vue';

export default {
  name: 'LocalEventPage',
  components: {
    EventHero, EventSummary, EventDetailsCard, EntitySection, CrewSection, EventGallery,
  },
  props: { event: { type: Object, required: true }, entityById: { type: Object, required: true } },
  computed: { details() { return { date: this.event.startDate, location: [this.event.city, this.event.region].filter(Boolean).join(', '), category: this.event.localEvent?.eventCategory }; } },
};
</script>

<style scoped>.local-page { background: #050505; }</style>
